const messages = {
  name: 'Consumo de Creditos',
  fields: {},
  submenu: {
    costCenter: 'Centro de Coste',
    pricing: 'Precios',
    creditBalance: 'Saldo de Creditos',
    creditTransaction: 'Transaccion de Creditos',
    creditEventLogs: 'Registro de Eventos de Credito',
    creditEventSummary: 'Resumen de Eventos de Credito',
  },
};

export default messages;
